(function () {
  'use strict';

  var sensitiveNamePattern = /password|token|secret|captcha|authenticity|csrf/i;
  var technicalNamePattern = /^(form_type|utf8|return_to)$/i;
  var modalId = 'DomoxaFormSuccessModal';
  var pendingStorageKey = 'domoxa_pending_form_submit';
  var attributionStorageKey = 'domoxa_attribution_parameters';
  var legacyUtmStorageKey = 'domoxa_utm_parameters';
  var pendingMaxAge = 60 * 60 * 1000;
  var attributionMaxAge = 30 * 60 * 1000;
  var consumedStorageKey = 'domoxa_consumed_submissions';
  var activePending = null;
  var consumedInMemory = {};
  var lastAttemptAt = 0;
  var utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var attributionKeys = [
    'gclid',
    'gbraid',
    'wbraid',
    'gad_source',
    'gad_campaignid'
  ].concat(utmKeys);
  var attributionFieldDefinitions = [
    { key: 'gclid', name: 'contact[Google Ads - GCLID]' },
    { key: 'gbraid', name: 'contact[Google Ads - GBRAID]' },
    { key: 'wbraid', name: 'contact[Google Ads - WBRAID]' },
    { key: 'gad_source', name: 'contact[Google Ads - Source]' },
    { key: 'gad_campaignid', name: 'contact[Google Ads - Campaign ID]' },
    { key: 'utm_source', name: 'contact[UTM - source]' },
    { key: 'utm_medium', name: 'contact[UTM - medium]' },
    { key: 'utm_campaign', name: 'contact[UTM - campaign]' },
    { key: 'utm_content', name: 'contact[UTM - content]' },
    { key: 'utm_term', name: 'contact[UTM - term]' },
    { key: 'landing_page_url', name: 'contact[Landing URL]' },
    { key: 'form_source', name: 'contact[Form source]' },
    { key: 'form_submitted_at', name: 'contact[Form submitted at]' },
    { key: 'submission_id', name: 'contact[Submission ID]' },
    { key: 'lead_segment', name: 'contact[Lead segment]' },
    { key: 'form_id', name: 'contact[Form ID]' }
  ];

  function normaliseFieldName(name) {
    return name
      .replace(/^contact\[/i, '')
      .replace(/\]$/, '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/gi, '_')
      .replace(/^_|_$/g, '');
  }

  function isTrackableField(field) {
    var name = field.name || '';
    var type = (field.type || '').toLowerCase();

    return name &&
      !technicalNamePattern.test(name) &&
      type !== 'submit' &&
      type !== 'button' &&
      type !== 'file' &&
      type !== 'password' &&
      !sensitiveNamePattern.test(name) &&
      !(field.dataset && field.dataset.domoxaAttributionField) &&
      (type !== 'checkbox' || field.checked) &&
      (type !== 'radio' || field.checked);
  }

  function collectFormFields(form) {
    var fields = [];

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!isTrackableField(field)) return;

      var key = normaliseFieldName(field.name);
      if (!key) return;

      if (fields.indexOf(key) === -1) fields.push(key);
    });

    return fields;
  }


  function readStorage(key) {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (error) { return null; }
  }

  function writeStorage(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (error) { }
  }

  function removeStorage(key) {
    try { sessionStorage.removeItem(key); } catch (error) { }
  }

  function getAttributionParameters() {
    var parameters = {};
    attributionKeys.forEach(function (key) { parameters[key] = ''; });
    parameters.landing_page_url = '';
    var search = new URLSearchParams(window.location.search);
    var incoming = {};
    attributionKeys.forEach(function (key) {
      var value = search.get(key);
      if (value) incoming[key] = value.trim().slice(0, 200);
    });
    var stored = readStorage(attributionStorageKey);
    var now = Date.now();
    if (stored && (!stored.savedAt || now - stored.savedAt > attributionMaxAge)) stored = null;
    var hasIncoming = Object.keys(incoming).length > 0;
    var sameArrival = stored && Object.keys(incoming).every(function (key) { return stored[key] === incoming[key]; });
    if (hasIncoming) {
      attributionKeys.forEach(function (key) { parameters[key] = incoming[key] || ''; });
      parameters.landing_page_url = sameArrival ? stored.landing_page_url : window.location.href.slice(0, 2000);
      parameters.savedAt = now;
      writeStorage(attributionStorageKey, parameters);
      removeStorage(legacyUtmStorageKey);
    } else if (stored) {
      attributionKeys.forEach(function (key) { parameters[key] = stored[key] || ''; });
      parameters.landing_page_url = stored.landing_page_url || '';
      parameters.savedAt = stored.savedAt;
    } else {
      removeStorage(attributionStorageKey);
      removeStorage(legacyUtmStorageKey);
    }
    return parameters;
  }

  function isShopifyLeadForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.id === 'captcha_form') return false;
    var visibleContactField = Array.prototype.some.call(form.elements, function (field) {
      return /^contact\[/.test(field.name || '') && !/^(hidden|submit|button)$/i.test(field.type || '');
    });
    if (!visibleContactField) return false;
    var action = (form.getAttribute('action') || '').toLowerCase();
    return action.indexOf('/contact') !== -1 || !!form.querySelector('[name^="contact["]');
  }

  function getFormType(form) {
    var identifier = ((form.id || '') + ' ' + (form.className || '')).toLowerCase();
    var tag = form.querySelector('[name="contact[tags]"]');
    return identifier.indexOf('newsletter') !== -1 || (tag && tag.value === 'newsletter') ? 'newsletter' : 'contact';
  }

  function getSegment(form) {
    if (form.dataset.domoxaLeadSegment) return form.dataset.domoxaLeadSegment;
    var tag = form.querySelector('[name="contact[Landing page]"]');
    var context = window.location.pathname + ' ' + (form.id || '') + ' ' + (tag ? tag.value : '');
    var pro = /professionnel|professional|gtb|gtc|multisite|b2b|pro-b/i;
    var segment = pro.test(context) ? 'b2b' : 'b2c';
    if (/\/pages\/contact\/?$/.test(window.location.pathname)) {
      var previous = readStorage('domoxa_lead_context');
      if (previous && Date.now() - previous.savedAt < attributionMaxAge) return previous.segment;
      var arrival = readStorage(attributionStorageKey);
      if (arrival && pro.test(arrival.landing_page_url || '')) return 'b2b';
    }
    writeStorage('domoxa_lead_context', {segment: segment, savedAt: Date.now()});
    return segment;
  }

  function setHidden(form, name, value, attribute) {
    var field = form.querySelector('[name="' + name + '"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    if (attribute) field.setAttribute('data-domoxa-attribution-field', attribute);
    field.value = value || '';
  }

  function ensureAttributionFields(form, submission) {
    var attribution = getAttributionParameters();
    if (getFormType(form) === 'newsletter') return attribution;
    attribution.form_source = 'Shopify contact form';
    attribution.form_submitted_at = submission ? submission.submittedAt : '';
    attribution.submission_id = submission ? submission.submissionId : '';
    attribution.lead_segment = getSegment(form);
    attribution.form_id = form.id || '';
    form.dataset.domoxaLeadSegment = attribution.lead_segment;
    attributionFieldDefinitions.forEach(function (definition) {
      setHidden(form, definition.name, attribution[definition.key], definition.key);
    });
    return attribution;
  }

  function getModal() {
    var modal = document.getElementById(modalId);
    if (modal) return modal;

    modal = document.createElement('dialog');
    modal.id = modalId;
    modal.className = 'domoxa-form-modal';
    modal.setAttribute('aria-labelledby', modalId + '-title');
    modal.setAttribute('aria-describedby', modalId + '-message');
    modal.innerHTML =
      '<div class="domoxa-form-modal__inner">' +
        '<button type="button" class="domoxa-form-modal__close" aria-label="Fermer">&times;</button>' +
        '<div class="domoxa-form-modal__icon" aria-hidden="true">✓</div>' +
        '<h2 id="' + modalId + '-title"></h2>' +
        '<p id="' + modalId + '-message"></p>' +
        '<button type="button" class="domoxa-form-modal__button">Fermer</button>' +
      '</div>';

    var style = document.createElement('style');
    style.textContent =
      '.domoxa-form-modal{border:0;border-radius:18px;max-width:min(92vw,520px);padding:0;color:#182522;box-shadow:0 24px 80px rgba(0,0,0,.24)}' +
      '.domoxa-form-modal::backdrop{background:rgba(14,29,25,.62)}' +
      '.domoxa-form-modal__inner{position:relative;padding:42px 36px 34px;text-align:center;background:#fff}' +
      '.domoxa-form-modal__close{position:absolute;top:12px;right:14px;border:0;background:transparent;color:#52635e;font-size:30px;line-height:1;cursor:pointer}' +
      '.domoxa-form-modal__icon{display:grid;place-items:center;width:54px;height:54px;margin:0 auto 18px;border-radius:50%;background:#e7f4e9;color:#2f8b4b;font-size:30px;font-weight:700}' +
      '.domoxa-form-modal h2{margin:0 0 10px;font-size:clamp(22px,4vw,30px);line-height:1.15}' +
      '.domoxa-form-modal p{margin:0 auto 24px;max-width:38ch;color:#52635e;line-height:1.55}' +
      '.domoxa-form-modal__button{border:0;border-radius:999px;padding:12px 24px;background:#182522;color:#fff;font:inherit;font-weight:600;cursor:pointer}' +
      '@media (max-width:600px){.domoxa-form-modal__inner{padding:38px 24px 28px}}';
    document.head.appendChild(style);
    document.body.appendChild(modal);

    function closeModal() {
      if (typeof modal.close === 'function' && modal.open) {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
      if (modal.lastActiveElement && typeof modal.lastActiveElement.focus === 'function') {
        modal.lastActiveElement.focus();
      }
    }

    modal.querySelector('.domoxa-form-modal__close').addEventListener('click', closeModal);
    modal.querySelector('.domoxa-form-modal__button').addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    return modal;
  }

  function showModal(formType, isSuccess) {
    var modal = getModal();
    var icon = modal.querySelector('.domoxa-form-modal__icon');
    var title = modal.querySelector('#' + modalId + '-title');
    var message = modal.querySelector('#' + modalId + '-message');

    icon.textContent = isSuccess ? '✓' : '!';
    title.textContent = isSuccess
      ? (formType === 'newsletter' ? 'Merci pour votre inscription !' : 'Merci, votre demande est bien envoyée')
      : 'Votre demande n’a pas pu être envoyée';
    message.textContent = isSuccess
      ? (formType === 'newsletter' ? 'Vous êtes bien inscrit à notre newsletter.' : 'Nous revenons vers vous rapidement.')
      : 'Un problème est survenu. Vérifiez votre connexion puis réessayez.';
    modal.querySelector('.domoxa-form-modal__button').textContent = isSuccess ? 'Fermer' : 'Réessayer';
    modal.lastActiveElement = document.activeElement;

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
    modal.querySelector('.domoxa-form-modal__button').focus();
  }

  function fieldValue(form, names) {
    for (var i = 0; i < names.length; i += 1) {
      var field = form.querySelector('[name="' + names[i] + '"]');
      if (field && field.value) return field.value.trim();
    }
    return '';
  }

  function newSubmissionId() {
    return window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : 'domoxa-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function normalisePhone(value) {
    var phone = value.replace(/[\s().-]/g, '');
    if (/^0[1-9]\d{8}$/.test(phone)) phone = '+33' + phone.slice(1);
    return /^\+\d{8,15}$/.test(phone) ? phone : '';
  }

  function publishUserData(form, pending) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function' || privacy.marketingAllowed() !== true) return;
    var email = fieldValue(form, ['contact[email]']).toLowerCase();
    var phone = normalisePhone(fieldValue(form, ['contact[Téléphone]', 'contact[phone]']));
    if (!email && !phone) return;
    window.domoxaAdsUserData = { email: email, phone_number: phone };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'domoxa_lead_user_data', form_id: pending.formId, lead_segment: pending.leadSegment, submission_id: pending.submissionId });
    window.setTimeout(function () { window.domoxaAdsUserData = null; }, 10000);
  }

  function rememberValidSubmission(form) {
    if (!isShopifyLeadForm(form)) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
    if (window.domoxaSyncConsent) window.domoxaSyncConsent();
    var now = Date.now();
    if (activePending && activePending.formId === form.id && now - lastAttemptAt < 1000) return;
    var pending = {
      submissionId: newSubmissionId(), formId: form.id || '', formType: getFormType(form),
      leadSegment: getSegment(form), formVariant: form.classList.contains('domoxa-lead-form--compact') ? 'compact' : 'detailed',
      values: collectFormFields(form), formPageLocation: window.location.href,
      formPagePath: window.location.pathname, submittedAt: new Date().toISOString(), savedAt: now,
      crm: { email: fieldValue(form, ['contact[email]']), firstName: fieldValue(form, ['contact[Nom complet]']), phone: fieldValue(form, ['contact[Téléphone]', 'contact[phone]']) }
    };
    pending.utm = ensureAttributionFields(form, pending);
    activePending = pending;
    lastAttemptAt = now;
    writeStorage(pendingStorageKey, pending);
    publishUserData(form, pending);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: 'domoxa_form_submit_attempt', form_id: pending.formId, lead_segment: pending.leadSegment, submission_id: pending.submissionId});
  }

  function readPendingForm() {
    var pending = readStorage(pendingStorageKey);
    if (!pending || !pending.savedAt || Date.now() - pending.savedAt > pendingMaxAge) {
      removeStorage(pendingStorageKey);
      return null;
    }
    if (!pending.submissionId && pending.formId) {
      pending.submissionId = 'legacy-' + pending.savedAt + '-' + pending.formId;
      pending.leadSegment = /professionnel|professional|gtb|multisite|b2b/i.test(pending.formPagePath || '') ? 'b2b' : 'b2c';
      pending.submittedAt = new Date(pending.savedAt).toISOString();
      pending.values = pending.values || [];
    }
    if (!pending.submissionId) return null;
    return pending;
  }

  function successMarker(form) {
    return !!form.querySelector('[data-domoxa-confirmed="true"], .domoxa-form-status--success, .domoxa-lead-form__status--success, .newsletter-form__message--success');
  }

  function publishSuccess(pending) {
    var consumed = readStorage(consumedStorageKey) || {};
    if (consumed[pending.submissionId] || consumedInMemory[pending.submissionId]) return;
    consumedInMemory[pending.submissionId] = true;
    consumed[pending.submissionId] = Date.now();
    Object.keys(consumed).forEach(function (key) { if (Date.now() - consumed[key] > 24 * 60 * 60 * 1000) delete consumed[key]; });
    writeStorage(consumedStorageKey, consumed);
    removeStorage(pendingStorageKey);
    var a = pending.utm || {};
    var data = {
      form_status: 'success', form_id: pending.formId, form_type: pending.formType,
      lead_segment: pending.leadSegment, form_variant: pending.formVariant,
      submission_id: pending.submissionId, form_fields: pending.values,
      form_page_location: pending.formPageLocation, form_page_path: pending.formPagePath,
      utm_source: a.utm_source || '', utm_medium: a.utm_medium || '', utm_campaign: a.utm_campaign || '',
      utm_content: a.utm_content || '', utm_term: a.utm_term || '', gclid: a.gclid || '', gbraid: a.gbraid || '',
      wbraid: a.wbraid || '', gad_source: a.gad_source || '', gad_campaignid: a.gad_campaignid || '', landing_page_url: a.landing_page_url || ''
    };
    window.dataLayer = window.dataLayer || [];
    if (pending.formType === 'contact') {
      window.dataLayer.push(Object.assign({event: 'form_submit'}, data));
      window.dataLayer.push(Object.assign({event: 'domoxa_lead_success'}, data));
      document.dispatchEvent(new CustomEvent('domoxa:lead-confirmed', {detail: pending}));
    } else {
      window.dataLayer.push(Object.assign({event: 'domoxa_newsletter_success'}, data));
    }
  }

  function cleanSuccessUrl() {
    var url = new URL(window.location.href);
    url.searchParams.delete('contact_posted');
    url.searchParams.delete('customer_posted');
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
  }

  function handleSuccessReturn() {
    var pending = readPendingForm();
    var params = new URLSearchParams(window.location.search);
    var hasReturnFlag = params.get('contact_posted') === 'true' || params.get('customer_posted') === 'true';
    if (!pending) {
      if (hasReturnFlag) cleanSuccessUrl();
      return;
    }
    var form = document.getElementById(pending.formId);
    if (!form || form.tagName !== 'FORM') return;
    var samePage = pending.formPagePath === window.location.pathname;
    var returnHash = window.location.hash.slice(1);
    var matchesHash = returnHash === pending.formId;
    if (!successMarker(form) || (!samePage && !matchesHash)) return;
    publishSuccess(pending);
    cleanSuccessUrl();
    showModal(pending.formType, true);
  }

  document.addEventListener('domoxa:lead-valid-submit', function (event) { rememberValidSubmission(event.detail.form); });
  window.addEventListener('pagehide', function () { window.domoxaAdsUserData = null; });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (isShopifyLeadForm(form) && form.dataset.domoxaLeadReady !== 'true' && !event.defaultPrevented) rememberValidSubmission(form);
  });

  function init() {
    getAttributionParameters();
    document.querySelectorAll('form').forEach(function (form) { if (isShopifyLeadForm(form)) ensureAttributionFields(form); });
    handleSuccessReturn();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
